<style scoped lang="scss">
@import "@/assets/scss/_inputs-shared.scss";
</style>
<template>
  <div class="step2-container">
    <PersonalDataForm
      :stepper-data="stepperData"
      :step1-data="step1Data"
      @update-stepper="updateStepper"
    />

    <!-- Botones de navegación -->
    <div class="nav-btns">
      <button class="back-btn" @click="goToPreviousStep">&larr; Volver</button>
      <button
        class="continue-btn"
        :disabled="!canContinue"
        @click="goToNextStep"
      >
        Continuar &rarr;
      </button>
    </div>

    <!-- Modal de carga -->
    <div v-if="showLoadingModal" class="loading-modal-overlay">
      <div
        class="loading-modal modal-dialog modal-pdv-small modal-dialog-centered"
      >
        <div class="modal-content relative">
          <div className="loader-ring">
            <img src="/images/featured/wait-icon.svg" alt="Cargando..." />
          </div>

          <div class="main-content">
            <h3>Esperas mientras procesamos tu solicitud</h3>
            <p>Esto puede demorar unos segundos</p>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
import PersonalDataForm from "@/components/step2/PersonalDataForm.vue";
import { studentsService, ordersService, salesforceService } from "@/services";


export default {
  name: "NewVersionStep2",
  components: {
    PersonalDataForm,

  },
  props: {
    stepperData: {
      type: Object,
      required: true,
    },
    step1Data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localFormData: {
        firstName: "",
        firstLastName: "",
        secondLastName: "",
        rut: "",
        email: "",
        phoneNumber: "",
        preferredLocation: null,
        selectedProgram: "",
        selectedProgramId: null,
        isFormValid: false,
      },
      // Estado del cupón aplicado
      appliedCoupon: null,
      // Datos para el componente de cupón
      couponData: {
        studentData: {},
        programData: {},
        selectedCourses: [],
        locationId: null,
      },
      showLoadingModal: false,
    };
  },
  computed: {
    canContinue() {
      return this.localFormData.isFormValid;
    },
  },
  methods: {
    updateStepper(data) {
      // Actualizar datos locales
      this.localFormData = { ...data };
      // Emitir al stepper wrapper
      this.$emit("update-data", data);
    },
    async goToNextStep() {
      if (!this.canContinue) return;

      // Mostrar modal de carga
      this.showLoadingModal = true;

      try {
        await this.$recaptchaLoaded();
        
        // Enviar datos a Salesforce (en paralelo, no bloquea el flujo principal)
        try {
          const salesforceData = this.buildSalesforceLeadData();
          
          // Enviar en paralelo sin esperar la respuesta
          salesforceService.createLead(salesforceData).catch(error => {
            console.warn('⚠️ Error al enviar a Salesforce (no crítico):', error);
          });
        } catch (salesforceError) {
          console.warn('⚠️ Error al preparar datos para Salesforce:', salesforceError);
        }
        
        // Flujo principal: crear estudiante y orden
        const payload = this.buildStudentPayload();
        const studentRes = await studentsService.createStudent(payload);
        const studentId = studentRes.id;
        const sessionState = JSON.stringify({
          students: [
            { ...studentRes, id: studentId, program: this.step1Data.program },
          ],
        });
        const orderRes = await ordersService.createOrder({
          sessionState,
          initialStudentId: studentId,
        });
        const orderId = orderRes.id;

        this.$emit("update-data", {
          ...this.localFormData,
          studentId,
          orderId,
          studentData: studentRes,
          orderData: orderRes,
          appliedCoupon: this.appliedCoupon,
        });

        this.$emit("next-step");
      } catch (error) {
        // Manejar error específico de RUT duplicado
        if (
          error.message === "El RUT se encuentra asignado a otro estudiante"
        ) {
          this.$swal.fire({
            position: "center",
            icon: "error",
            title: "RUT duplicado",
            text: error.message,
            showConfirmButton: true,
            confirmButtonText: "Aceptar",
          });
        } else {
          this.$swal.fire({
            position: "center",
            icon: "error",
            title: "Error",
            text:
              "Ocurrió un error al enviar los datos: " +
              (error?.response?.data?.message || error.message),
            showConfirmButton: true,
            confirmButtonText: "Aceptar",
          });
        }
      } finally {
        // Ocultar modal de carga
        this.showLoadingModal = false;
      }
    },
    goToPreviousStep() {
      this.$emit("previous-step");
    },
    buildStudentPayload() {
      // Mapear los datos del formulario y del paso 1
      const {
        firstName,
        firstLastName,
        secondLastName,
        rut,
        email,
        phoneNumber,
        birthDate,
        preferredLocation,
      } = this.localFormData;
      // Si preferredLocation es null, usar un objeto vacío
      const venue = preferredLocation || {};

      // Formatear fecha de nacimiento a formato DD-MM-YYYY para la API
      let formattedBirthday = null;
      if (birthDate) {
        try {
          // birthDate viene en formato DD/MM/YYYY desde el formulario
          // Convertir DD/MM/YYYY a DD-MM-YYYY
          formattedBirthday = birthDate.replace(/\//g, "-");
        } catch (error) {
          console.error("Error al formatear fecha de nacimiento:", error);
        }
      }

      return {
        name: firstName,
        fatherLastName: firstLastName,
        lastName: secondLastName,
        rut,
        email,
        phoneNumber,
        birthday: formattedBirthday, // Enviar en formato DD-MM-YYYY
        preferredVenue: venue,
        sede: venue,
      };
    },
    
    buildSalesforceLeadData() {
      // Mapear los datos para Salesforce
      const {
        firstName,
        firstLastName,
        secondLastName,
        rut,
        email,
        phoneNumber,
        birthDate,
        preferredLocation,
      } = this.localFormData;
      
      // Construir apellidos completos
      const lastName = [firstLastName, secondLastName].filter(Boolean).join(' ');
      
      // Obtener nombre del programa del paso 1
      const programName = this.step1Data?.program?.name || this.step1Data?.program || 'Programa no especificado';
      
      // Obtener nombre de la sede
      const campusName = preferredLocation?.name || 'Sede no especificada';
      const phone = phoneNumber ? '+56' + phoneNumber : '';
      
            // Formatear RUT sin puntos, solo con guión
      const formattedRut = rut ? rut.replace(/\./g, '') : '';
      
      // Formatear fecha de nacimiento a formato YYYY-MM-DD
      let formattedBirthDate = '';
      if (birthDate) {
        // birthDate viene en formato DD/MM/YYYY desde el formulario
        // Convertir DD/MM/YYYY a YYYY-MM-DD
        const parts = birthDate.split('/');
        if (parts.length === 3) {
          const day = parts[0];
          const month = parts[1];
          const year = parts[2];
          formattedBirthDate = `${year}-${month}-${day}`;
        } else {
          formattedBirthDate = birthDate.replace(/\//g, '-');
        }
      }

      //Obtener el source desde query params route
      const SOURCE = this.$route.query.utm_source || 'directo';
      const MEDIUM = this.$route.query.utm_medium || 'none';
      const CAMPAIGN = this.$route.query.utm_campaign || 'none';
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      const DEVICE = isMobile ? 'Mobile' : 'Desktop';
      return {
        firstName: firstName || '',
        lastName: lastName,
        rut: formattedRut,
        email: email || '',
        phone: phone,
        birthDate: formattedBirthDate,
        landing: "Carro Abandonado",
        origin: "Landing",
        source: SOURCE, //Source__c = Type
        medium: MEDIUM, //Medium__c = Facebook
        device: DEVICE, //Device__c = Mobile o Desktop
        campaign: CAMPAIGN, //Campaign__c = Campaign Name
        campus: campusName,
        program: programName,
        authorizationPublicitary: true
      };
    },
  },
};
</script>

<style scoped>
.step2-container {
  max-width: 936px;
  margin: 0 auto;
  padding: 16px;
}

.nav-btns {
  display: flex;
  justify-content: center;
  gap: 18px;
  margin: 28px 0 18px 0;
  flex-wrap: wrap;
}

.back-btn,
.continue-btn {
  border: none;
  border-radius: 24px;
  padding: 10px 26px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  background: #f5f5f5;
  color: #888;
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;
}

.back-btn:hover {
  background: #e0e0e0;
  color: #666;
}

/* Botón continuar habilitado: fondo negro, texto blanco */
.continue-btn:enabled {
  background: #111;
  color: #fff;
}

.continue-btn:enabled:hover {
  background: #333;
}

.continue-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: #111;
  color: #fff;
}

/* Modal de carga */
.loading-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-modal {
  width: 100%;
  max-width: 700px;
  height: auto;
  min-height: 400px;
  margin: 20px;
}

.modal-content {
  border-radius: 24px;
  border: 2px solid #000;
  background: #fff;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  min-height: 300px;
}

.loader-ring {
  margin-bottom: 24px;
}

.loader-ring img {
  width: 60px;
  height: 60px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.main-content {
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.main-content h3 {
  color: #000;
  text-align: center;
  font-family: "Poppins-Bold", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  margin: 0 0 16px 0;
}

.main-content p {
  color: #666;
  text-align: center;
  font-family: "Poppins-Regular", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
}

/* ===== RESPONSIVE DESIGN ===== */

/* Mobile Small (320px - 480px) */
@media (max-width: 480px) {
  .step2-container {
    padding: 12px;
  }
  
  .nav-btns {
    gap: 12px;
    margin: 20px 0 16px 0;
  }
  
  .back-btn,
  .continue-btn {
    padding: 12px 20px;
    font-size: 0.9rem;
    border-radius: 20px;
    width: 100%;
  }
  
  /* Cambiar orden en mobile: Continuar arriba, Volver abajo */
  .continue-btn {
    order: -1;
  }
  
  .back-btn {
    order: 1;
  }
  
  .loading-modal {
    margin: 16px;
    min-height: 350px;
  }
  
  .modal-content {
    padding: 20px 16px;
    min-height: 280px;
    border-radius: 20px;
  }
  
  .loader-ring img {
    width: 50px;
    height: 50px;
  }
  
  .main-content h3 {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 12px;
  }
  
  .main-content p {
    font-size: 14px;
    line-height: 20px;
  }
}

/* Mobile Medium (481px - 767px) */
@media (min-width: 481px) and (max-width: 767px) {
  .step2-container {
    padding: 16px;
  }
  
  .nav-btns {
    gap: 16px;
    margin: 24px 0 18px 0;
  }
  
  .back-btn,
  .continue-btn {
    padding: 12px 24px;
    font-size: 0.95rem;
  }
  
  /* Cambiar orden en mobile: Continuar arriba, Volver abajo */
  .continue-btn {
    order: -1;
  }
  
  .back-btn {
    order: 1;
  }
  
  .loading-modal {
    margin: 20px;
    min-height: 380px;
  }
  
  .modal-content {
    padding: 24px 20px;
    min-height: 300px;
  }
  
  .main-content h3 {
    font-size: 19px;
    line-height: 26px;
  }
  
  .main-content p {
    font-size: 15px;
    line-height: 22px;
  }
}

/* Tablet (768px - 1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
  .step2-container {
    padding: 20px;
    max-width: 900px;
  }
  
  .nav-btns {
    gap: 18px;
    margin: 28px 0 20px 0;
  }
  
  .back-btn,
  .continue-btn {
    padding: 12px 28px;
    font-size: 1rem;
  }
  
  .loading-modal {
    max-width: 600px;
    min-height: 450px;
  }
  
  .modal-content {
    padding: 28px 24px;
    min-height: 350px;
    flex-direction: row;
    gap: 24px;
  }
  
  .loader-ring {
    margin-bottom: 0;
  }
  
  .loader-ring img {
    width: 70px;
    height: 70px;
  }
  
  .main-content h3 {
    font-size: 22px;
    line-height: 30px;
  }
  
  .main-content p {
    font-size: 16px;
    line-height: 24px;
  }
}

/* Desktop (1024px+) */
@media (min-width: 1024px) {
  .step2-container {
    padding: 24px;
    max-width: 936px;
  }
  
  .nav-btns {
    gap: 20px;
    margin: 32px 0 24px 0;
  }
  
  .back-btn,
  .continue-btn {
    padding: 14px 30px;
    font-size: 1rem;
  }
  
  .loading-modal {
    max-width: 700px;
    height: 500px;
  }
  
  .modal-content {
    padding: 24px 150px;
    min-height: 400px;
    flex-direction: row;
    gap: 32px;
  }
  
  .loader-ring {
    margin-bottom: 0;
  }
  
  .loader-ring img {
    width: 80px;
    height: 80px;
  }
  
  .main-content h3 {
    font-size: 24px;
    line-height: 32px;
  }
  
  .main-content p {
    font-size: 16px;
    line-height: 24px;
  }
}

/* Large Desktop (1280px+) */
@media (min-width: 1280px) {
  .step2-container {
    max-width: 1400px;
  }
  
  .loading-modal {
    max-width: 800px;
    height: 550px;
  }
  
  .modal-content {
    padding: 32px 180px;
    min-height: 450px;
  }
  
  .loader-ring img {
    width: 90px;
    height: 90px;
  }
  
  .main-content h3 {
    font-size: 26px;
    line-height: 36px;
  }
  
  .main-content p {
    font-size: 18px;
    line-height: 26px;
  }
}

/* Landscape Mobile */
@media (max-height: 500px) and (orientation: landscape) {
  .step2-container {
    padding: 12px;
  }
  
  .nav-btns {
    margin: 16px 0 12px 0;
  }
  
  .loading-modal {
    min-height: 300px;
  }
  
  .modal-content {
    min-height: 250px;
    padding: 20px 24px;
  }
  
  .loader-ring img {
    width: 40px;
    height: 40px;
  }
  
  .main-content h3 {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 8px;
  }
  
  .main-content p {
    font-size: 14px;
    line-height: 18px;
  }
}

/* High DPI displays */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
  .back-btn,
  .continue-btn {
    border-width: 1px;
  }
  
  .modal-content {
    border-width: 1px;
  }
}

/* Print styles */
@media print {
  .step2-container {
    background: white;
    padding: 20px;
  }
  
  .nav-btns {
    display: none;
  }
  
  .loading-modal-overlay {
    display: none;
  }
}

/* Accessibility improvements */
@media (prefers-reduced-motion: reduce) {
  .back-btn,
  .continue-btn {
    transition: none;
  }
  
  .loader-ring img {
    animation: none;
  }
}
</style>
